'use strict';

var processInclude = require('BASE/util');

$(document).ready(function() {
  $('body').on('click', 'button.filter-results', function() {
    if ($('.refinement-bar, .modal-background').hasClass('d-md-none')) {
      $('.refinement-bar, .modal-background').removeClass('d-md-none');
    }
  });
  processInclude(require('BASE/search/search'));
  // processInclude(require('BASE/product/quickView'));
});

document.addEventListener('DOMContentLoaded', function() {  
  var buttons = document.getElementsByClassName('btn-download-gift');  
  for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function() {
          var voucherUrl = this.getAttribute('data-voucher-url');

          if (voucherUrl) {              
              window.open(voucherUrl, '_blank');
          } else {              
              alert('Il voucher non è disponibile per il download.');
          }
      });
  }
});